import { Button, Icon, styled } from '@qcx/ui';
import { faCommentDots } from '@fortawesome/pro-light-svg-icons';
import { useCallback } from 'react';

export type CommentsScrollButtonProps = React.ComponentProps<
  typeof StyledButton
> & {
  targetId?: string; // por padrão vai para #section-comments
};

export const CommentsScrollButton = ({
  targetId = 'section-comments'
}: CommentsScrollButtonProps) => {
  const handleScroll = useCallback(() => {
    const el = document.querySelector(`#${targetId}`);

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [targetId]);

  return (
    <StyledButton aria-label="Scroll to comments" onClick={handleScroll}>
      <Icon css={{ minMaxH: 20, color: '$neutral500' }} icon={faCommentDots} />
    </StyledButton>
  );
};

const StyledButton = styled(Button, {
  borderRadius: 38,
  color: '$neutral600 !important',
  flexCenter: true,
  px: '$4 !important'
});
